export function getPriceRange(steps) {
    let min = 0;
    let max = 0;
    const groups = [];
    let price = 0;
    const hiddenParents = [];

    for (const i in steps) {
        if (parseInt(steps[i].state_id) === 99) continue;
        if (parseInt(steps[i].billable) === 0) continue;
        if (typeof steps[i].hidden !== "undefined" && steps[i].hidden) continue;

        if (steps[i].parent_id === null) {
            price += steps[i].price;
            continue;
        }
        if (steps[i].parent_id === steps[i].id) {
            continue;
        }
        if (typeof(groups[steps[i].parent_id])==="undefined") {
            groups[steps[i].parent_id] = {
                min: steps[i].price,
                max: steps[i].price,
            };
            continue;
        }
        if (steps[i].price<groups[steps[i].parent_id].min) groups[steps[i].parent_id].min = steps[i].price;
        if (steps[i].price>groups[steps[i].parent_id].max) groups[steps[i].parent_id].max = steps[i].price;
    }

    min = price;
    max = price;

    for (const j in groups) {
        min += groups[j].min;
        max += groups[j].max;
    }

    if (isNaN(min)) min = 0;
    if (isNaN(max)) max = 0;

    // Debug.info('Price calculated',steps, min, max);

    return ({
        min: Number(min.toFixed(4)+0),
        max: Number(max.toFixed(4)+0),
    });
}

export function calcStepPrice(step) {
    step.unit_price = parseFloat(step.unit_price);
    if (isNaN(step.unit_price)) step.unit_price = 0;
    if (parseInt(step.state_id)===100 && step.unit_price > 0) step.unit_price = 0-Math.abs(step.unit_price);

    if (typeof(step.batch_price)!=="undefined" && step.batch_price) {
        step.price = step.unit_price;
    } else {
        step.price = step.amount * step.unit_price;
    }
    return step;
}

export function isMissingTeethInSelection(selection, status, forced) {
    this.status = status;
    if (typeof(selection)==="undefined") {
        var selection = this.selectedTeeth;
    }
    if (typeof(all)==="undefined") {
        var forced = 0;
    }
    let missing = false;
    let missingCount = 0;
    for (const selectionIndex in selection) {
        // Search status data for set as missing
        for (const statusIndex in this.status) {
            if (this.status[statusIndex].tooth_id == selection[selectionIndex] && this.status[statusIndex].state_id == 2) {
                missing = true;
                missingCount++;
                break;
            }
        }
        // Try to detect extractions
        for (const j in this.plans) {
            for (const k in this.plans[j].steps) {
                if (this.plans[j].steps[k].tooth_id == selection[selectionIndex] && this.plans[j].steps[k].state_pid == "33") {
                    missing = true;
                    missingCount++;
                    break;
                }
            }
        }
    }
    if (forced) return (selection.length === missingCount);
    else return missing;
}

export function getSurfaceText(surface) {
    let text = "";
    const ordered = ["M", "O1", "O2", "D", "F", "L", "B", "P"];
    for (const i in ordered) {
        if (surface.indexOf(ordered[i])>=0) text += ordered[i];
    }
    return text.replace("O1O2", "O");
}

export function generateRandom(l) {
    let text = "";
    const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (let i = 0; i < l; i++) text += possible.charAt(Math.floor(Math.random() * possible.length));
    return text;
}

/**
 * Validate email address, taken from Chromium
 * Called by validators
 */
export function validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

/**
 * Validate phone number
 * Called by validators
 * @todo: implement https://github.com/googlei18n/libphonenumber
 */
export function validatePhone(phone) {
    try {
        if (phone === null || phone.length<8) return false;
        return true;
    } catch(error) {
        captureException(error);
        return false;
    }
}


export function deepMergeObjects(current, ...updates) {
    updates.forEach((update) => {
        for (let key of Object.keys(update)) {
            if (!current.hasOwnProperty(key) || typeof update[key] !== "object") current[key] = update[key];
            else Helper.deepMergeObjects(current[key], update[key]);
        }
    });
    return current;
}
